export const MODULE = "kses";

export const SET_KSES = `${MODULE}/SET_KSES`;
export const SET_MORE_KSES = `${MODULE}/SET_MORE_KSES`;
export const SET_KSES_LOADING = `${MODULE}/SET_KSES_LOADING`;
export const RESET_KSES = `${MODULE}/RESET_KSES`;